import { SITE_URL } from "./helperFunctions";
import { FAKE_NEW_INVOICE, FAKE_NETWORK } from "./fakeData";

const ENDPOINTS = {
  GET_SHOPIFY_ORDERS: process.env.REACT_APP_GET_SHOPIFY_ORDERS_ID,
  SEND_QBO_ORDERS: process.env.REACT_APP_SEND_QBO_ORDERS_ID,
  GET_SHOPIFY_INVOICES: process.env.REACT_APP_GET_SHOPIFY_INVOICES_ID,
  SEND_QBO_INVOICES: process.env.REACT_APP_SEND_QBO_INVOICES_ID,
  GET_SHOPIFY_INVENTORY: process.env.REACT_APP_GET_SHOPIFY_INVENTORY_ID,
  GET_QBO_INVENTORY: process.env.REACT_APP_GET_QBO_INVENTORY_ID,
  SET_SHOPIFY_INVENTORY: process.env.REACT_APP_SET_SHOPIFY_INVENTORY_ID,
  GET_SHOPIFY_PRODUCTS: process.env.REACT_APP_GET_SHOPIFY_PRODUCTS_ID,
  GET_QBO_PRODUCTS: process.env.REACT_APP_GET_QBO_PRODUCTS_ID,
  GET_SHOPIFY_CUSTOMERS: process.env.REACT_APP_GET_SHOPIFY_CUSTOMERS_ID,
  GET_QBO_CUSTOMERS: process.env.REACT_APP_GET_QBO_CUSTOMERS_ID,
};

const dataStreamMap = (connOneId, connTwoId) => {
  const products = [
    workflowPayload('Get Products from Shopify', connOneId, ENDPOINTS.GET_SHOPIFY_PRODUCTS), {
      transform: "payload[:key] = [:sku, :reference_name]; payload[:shopify_database_id] = payload[:database_id]; result = payload",
    },
    workflowPayload('Get Products from QuickBooks', connTwoId, ENDPOINTS.GET_QBO_PRODUCTS), {
      transform: "payload[:key] = [:sku, :reference_name]; payload[:qbo_database_id] = payload[:database_id]; result = payload",
    },
  ]

  const customers = [
    workflowPayload('Get Customers from Shopify', connOneId, ENDPOINTS.GET_SHOPIFY_CUSTOMERS),{
      transform: "payload[:key] = [:email, :reference_name]; payload[:shopify_database_id] = payload[:database_id]; result = payload",
    },
    workflowPayload('Get Customers from QuickBooks', connTwoId, ENDPOINTS.GET_QBO_CUSTOMERS), {
      transform: "payload[:key] = [:email, :reference_name]; payload[:qbo_database_id] = payload[:database_id]; result = payload",
    },
  ]

  const orders = [
    workflowPayload('1. Get Orders', connOneId, ENDPOINTS.GET_SHOPIFY_ORDERS),
    workflowPayload('2. Send Orders', connTwoId, ENDPOINTS.SEND_QBO_ORDERS, { 
      triggerIds: [1], 
      transform: "payload[:customer][:database_id] = payload.dig(:customer, :qbo_database_id); payload.dig(:line_items)&.each{|i| i[:database_id] = i[:qbo_database_id]}; result[key] = payload",
      properties: [
        {
          name: "workflow_relationships",
          value: '[{"object":"product","location":"line_items","key":"sku"}, {"object":"customer","location":"customer","key":"email"}]',
          property_type: "text",
          label: "Relationships",
          required: false
        }
      ]
    }),
    ...products,
    ...customers
  ]

  const invoices = [
    workflowPayload('1. Get Invoices', connOneId, ENDPOINTS.GET_SHOPIFY_INVOICES),
    workflowPayload('2. Send Invoices', connTwoId, ENDPOINTS.SEND_QBO_INVOICES, { 
      triggerIds: [1],
      transform: "payload[:customer][:database_id] = payload.dig(:customer, :qbo_database_id); payload.dig(:line_items)&.each{|i| i[:database_id] = i[:qbo_database_id]}; result[key] = payload",
      properties: [
        {
          name: "workflow_relationships",
          value: '[{"object":"product","location":"line_items","key":"sku"}, {"object":"customer","location":"customer","key":"email"}]',
          property_type: "text",
          label: "Relationships",
          required: false
        }
      ]
    }),
    ...products,
    ...customers
  ]

  const inventory = [
    workflowPayload('1a. Get Inventory', connOneId, ENDPOINTS.GET_SHOPIFY_INVENTORY, { interval: 1440 }),
    workflowPayload('1b. Get Inventory', connTwoId, ENDPOINTS.GET_QBO_INVENTORY, { interval: 1440 }),
    workflowPayload('2. Set Inventory', connOneId, ENDPOINTS.SET_SHOPIFY_INVENTORY, { triggerIds: [2] })
  ]

  return { orders, invoices, inventory }
};

function workflowPayload (name, connectionId, endpointId, options = {}) {
  const { 
    triggerIds = [], 
    interval = null, 
    transform = "",
    properties = []
  } = options
  
  return {
    name,
    connection_id: connectionId,
    endpoint_id: endpointId,
    ...(triggerIds.length && { trigger_ids: triggerIds }),
    ...(interval && { interval: interval }),
    transform,
    properties_attributes: properties
  }
}

const handleResponse = async (response) => {
  if (response?.ok) {
    return {
      isAdmin: false,
      ok: true,
      msg: null,
    };
  }

  const text = await response.text();
  let msg;
  try {
    msg = JSON.parse(text).error.message;
  } catch (error) {
    console.log("error happened and we caught it", error);
    msg = "Something went wrong!";
  }

  return {
    isAdmin: false,
    ok: false,
    msg,
  };
};

export const getReq = async (url) => {
  // TODO: why does this loop?
  console.log(`Making GET request to: ${SITE_URL}${url}`);
  const response = await fetch(`${SITE_URL}${url}`, { credentials: "include" });
  if (response.status === 401) {
    throw new Error("Unauthorized");
  }
  return response.json();
};

export const postReq = async (url, body, methodOverride = "POST") => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  const opts = {
    method: methodOverride,
    credentials: "include",
    headers: myHeaders,
    body,
  };
  console.log(
    `Making ${methodOverride} request to: ${SITE_URL}${url} with opts ${opts}`
  );
  const response = await fetch(`${SITE_URL}${url}`, opts);
  if (response.status === 401) {
    throw new Error("Unauthorized");
  }

  return handleResponse(response);
};

export const deleteReq = async (url) => {
  const response = await fetch(`${SITE_URL}${url}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (response.status === 401) {
    throw new Error("Unauthorized");
  }

  return handleResponse(response);
}

export async function postInvoice(companyId) {
  // let url = `/companies/${companyId}`/invoices`;
  // fetch(url, { method: 'POST', headers, body: {} })

  await FAKE_NETWORK();
  return { ...FAKE_NEW_INVOICE, companyId };
}

export async function login(email, password) {
  const body = JSON.stringify({ email, password });
  return await postReq(`/sign_in`, body);
}

export async function userInfo() {
  const url = `/users/me`;
  return await getReq(url);
}

export async function logout() {
  // Server should nullify the HTTP Only Tokens
  const url = `/sign_out`;
  return await deleteReq(url);
}

export async function signup(data) {
  const body = JSON.stringify({
    first_name: data.firstName,
    last_name: data.lastName,
    email: data.email,
    company_name: data.company,
    password: data.password,
    // The following are currently not supported nor used in FlowLink:
    // phone_number: data.phone,
    // password_confirmation: data.passwordConfirmation,
    // feedback: data.feedback,
  });
  return postReq(`/sign_up`, body);
}

export async function resetPassword(email) {
  const body = JSON.stringify({ email });
  return postReq(`/password/reset`, body);
}

export async function editPassword({ password, reset_password_token }) {
  const body = JSON.stringify({ password, reset_password_token });
  return postReq(`/password/update`, body, "PUT");
}

export async function createWorkflows({ dataTypes, connOneId, connTwoId }) {
  const dataStreams = dataStreamMap(connOneId, connTwoId)

  //  Build object with endpoint ids as key (for deduplication)
  const workflowsByEndpointId = dataTypes.reduce((acc, type) => {
    const workflows = dataStreams[type] || [];
    workflows.forEach(wf => {
      acc[wf.endpoint_id] = wf; // overwrite duplicates
    });
    return acc;
  }, {});

  // Extract values to get unique workflows as an array
  const workflows = Object.values(workflowsByEndpointId);

  return await postReq(`/workflows/batch`, JSON.stringify({ workflows }));
}
